/**
 * Copyright(c) 2024 Magrabi
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @author Indrajit
 */
"use server";

import { getFromCookieMetadata, setInCookieMetadata, removeFromCookie } from "../apiUtils/cookieDataUtils";

export const getFromCookieMetadataSA = async (key: string) => getFromCookieMetadata(key);

export const setInCookieMetadataSA = async (key: string, value: string) => setInCookieMetadata(key, value);

export const removeFromCookieAS = async (key: string) => removeFromCookie(key);
